import {
  Box,
  Button,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  Select,
} from '@chakra-ui/react'
import { SearchIcon, EditIcon } from '@chakra-ui/icons'
import type { InboxFilterKey } from './types'
import { INBOX_FILTERS } from './types'
import { useThemeColors } from '@/hooks/useThemeColors'

type Props = {
  value: InboxFilterKey
  onChange: (v: InboxFilterKey) => void
  search?: string
  onSearchChange?: (v: string) => void
}

export const TicketFilterSelect = ({
  value,
  onChange,
  search = '',
  onSearchChange,
}: Props) => {
  const colors = useThemeColors()

  const focusStyles = {
    borderColor: colors.inputBorder, 
    boxShadow: 'none',
  }

  return (
    <Box
      p="16px"
      borderBottom="1px solid"
      borderColor={colors.borderLight}
      bg={colors.cardBg}
    >
      <Flex gap="10px" mb="10px" align="center">
        <Button
          leftIcon={<EditIcon />}
          bg={colors.primary}
          _hover={{ bg: colors.primaryHover }}
          _active={{ bg: colors.buttonActiveBg }}
          color="white"
          borderRadius="8px"
          size="sm"
          boxShadow="sm"
        >
          Compose New
        </Button>

        <Select
          value={value}
          onChange={(e) => onChange(e.target.value as InboxFilterKey)}
          size="sm"
          borderRadius="8px"
          w="150px"
          bg={colors.inputBg}
          borderColor={colors.inputBorder}
          _hover={{ borderColor: colors.inputborderHover }}
          _focusVisible={focusStyles} 
        >
          {INBOX_FILTERS.map((f) => (
            <option key={f.key} value={f.key}>
              {f.label}
            </option>
          ))}
        </Select>
      </Flex>

      <InputGroup>
        <InputLeftElement
          pointerEvents="none"
          h="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <SearchIcon color={colors.textMuted} />
        </InputLeftElement>

        <Input
          value={search}
          onChange={(e) => onSearchChange?.(e.target.value)}
          placeholder="Search"
          size="sm"
          borderRadius="8px"
          bg={colors.inputBg}
          borderColor={colors.inputBorder}
          pl="36px" 
          _hover={{ borderColor: colors.inputborderHover }}
          _focusVisible={focusStyles} 
        />
      </InputGroup>
    </Box>
  )
}
